import type { ValkyrieLambdaV1Config } from '../types/valkyrie-lambda-v1';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const isEmpty = (value: unknown): boolean =>
  value === '' ||
  value === null ||
  value === undefined ||
  (Array.isArray(value) && value.length === 0) ||
  (isPlainObject(value) && Object.keys(value).length === 0);

const prune = (obj: Record<string, unknown>) => {
  for (const key of Object.keys(obj)) if (isEmpty(obj[key])) delete obj[key];
};

/** Load a raw config.json for the editor: coerce to an object and stamp the template name. */
export function normalizeValkyrieLambdaV1Config(raw: unknown): ValkyrieLambdaV1Config {
  const config = (isPlainObject(raw) ? structuredClone(raw) : {}) as ValkyrieLambdaV1Config;
  config.template_name = 'valkyrie-lambda-v1';
  return config;
}

/**
 * Minimize a config for writing back: drop blank env var values, then every empty top-level value
 * (each equals the module default). Unknown keys pass through. Idempotent; does not mutate input.
 */
export function formatValkyrieLambdaV1Config(
  input: ValkyrieLambdaV1Config,
): ValkyrieLambdaV1Config {
  const config = normalizeValkyrieLambdaV1Config(input);
  if (isPlainObject(config.environment_variables)) prune(config.environment_variables);
  prune(config);
  return config;
}
